var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBook = function SvgBook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20.5 25.97V28H23a1 1 0 1 1 0 2H3a3 3 0 0 1-2.983-3.318A1 1 0 0 1 0 26.5V4a4 4 0 0 1 4-4h16a4 4 0 0 1 4 4v18a4 4 0 0 1-3.5 3.97M2 4a2 2 0 0 1 2-2v8.5a2.5 2.5 0 0 0 5 0V2h11a2 2 0 0 1 2 2v18a2 2 0 0 1-2 2H3c-.35 0-.687.06-1 .17zm4 6.5V2h1v8.5a.5.5 0 0 1-1 0M3 26h15.5v2H3a1 1 0 1 1 0-2",
    clipRule: "evenodd"
  })));
};
export default SvgBook;